import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../components/pages/authentication/authentication/authentication.service';
import { RecurrenceRequest } from '../models/recurrence.model';

@Injectable({
	providedIn: 'root'
})
export class TokenAlphaService {
	private url = environment.api + "api/erp/tokenalpha";

	constructor(
		private http: HttpClient,
		private authService: AuthenticationService
	) {

	}

	useToken(token) {
		return this.http.get(this.url + "/use", {
			params: {
				token: token
			}
		});
	}

	createToken() {
		return this.http.post(this.url + "/create", null);
	}
}